import { render, staticRenderFns } from "./ScoreRow.vue?vue&type=template&id=0fa5cba5&scoped=true&"
import script from "./ScoreRow.vue?vue&type=script&lang=js&"
export * from "./ScoreRow.vue?vue&type=script&lang=js&"
import style0 from "./ScoreRow.vue?vue&type=style&index=0&id=0fa5cba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa5cba5",
  null
  
)

export default component.exports